(function () {
  'use strict';

  /* Arrow navigation for .jk-product-gallery
     Delegates from document so Theme Editor section reloads are handled
     automatically without re-binding. Calls media-gallery.js setActiveMedia()
     which also syncs the thumbnail active state. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jk-gallery-arrow]');
    if (!btn) return;

    var gallery = btn.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    var list = gallery.querySelector('.product__media-list');
    if (!list) return;

    var items = Array.from(list.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;

    var active = list.querySelector('.product__media-item.is-active') || items[0];
    var idx    = items.indexOf(active);
    var dir    = btn.dataset.jkGalleryArrow;
    var next   = dir === 'prev'
      ? (idx - 1 + items.length) % items.length
      : (idx + 1) % items.length;

    gallery.setActiveMedia(items[next].dataset.mediaId, false);
  });
})();

/* Mobile dots/counter ─────────────────────────────────────────────────────
   Listens to Dawn's SliderComponent `slideChanged` CustomEvent (fired on
   every scroll/swipe and button click) and mirrors the current page index
   to our .jk-gallery-progress dots or counter.

   Variant change → setActiveMedia → slider scrolls → slideChanged fires
   → dots update automatically. No separate state needed.              */
(function () {
  'use strict';

  function initProgress(gallery) {
    if (gallery.dataset.jkProgressInit) return; /* guard against double-bind */
    gallery.dataset.jkProgressInit = '1';

    var progress = gallery.querySelector('.jk-gallery-progress');
    if (!progress) return;

    /* GalleryViewer id = "GalleryViewer-{sectionId}" */
    var viewer = document.getElementById(
      gallery.id.replace('MediaGallery-', 'GalleryViewer-')
    );
    if (!viewer) return;

    var isDots = progress.classList.contains('jk-gallery-progress--dots');

    viewer.addEventListener('slideChanged', function (e) {
      var page = e.detail && e.detail.currentPage;
      if (!page) return;

      if (isDots) {
        var dots = progress.querySelectorAll('.jk-gallery-dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === page - 1);
        }
      } else {
        var cur = progress.querySelector('.jk-gallery-count__current');
        if (cur) cur.textContent = page;
      }
    });
  }

  function initAll() {
    Array.from(document.querySelectorAll('media-gallery.jk-product-gallery'))
      .forEach(initProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme Editor: re-init when a section is reloaded in the editor */
  document.addEventListener('shopify:section:load', initAll);
})();
